export default __webpack_public_path__ + "static/media/prestation.1c359b3c.gif";